export default String.raw`

{% if include -%}
    {% assign pageNumber = include -%}
{% else -%}
    {% assign pageNumber = 1 -%}
{% endif -%}

<div class="cart-container order-template-js parent-container-js replace-with-js {% if customer.Cart.Inquiry -%} inquiry-container-js {% endif -%}" 
     data-template="elements/cart/cart-1.html" 
     data-include="{{pageNumber}}"
>
    {% assign orderStep = 'First' -%}
    {% if page.QueryString contains 'empty-inquiry=true' -%}
        {% assign orderStep = 'First' -%}
    {% elseif cart.OrderStep == 'ThankYou' -%}
        {% assign orderStep = 'ThankYou' -%}
    {% elseif cart.OrderStep == "Start" and page.Cookies.cartAuthenticateStep == 'true' and usr.Authenticated == false -%}
        {% assign orderStep = 'Second' -%}
    {% elseif cart.OrderStep == 'CustomerData' or cart.OrderStep == 'Summary' -%}
        {% assign orderStep = 'Third' -%}
    {% endif -%}

    {% if orderStep == 'Second' or orderStep == 'Third' -%}
        {% include 'partials/common/header/header-top-bar.html' -%}
        <div class="cart-header">
            <div class="cart-header__logo">
                <a href="{{ page.BaseHref }}{{ config.DefinedPages.Home.Url | Replace: '^\./', '' }}">
                    <img src="{{config.Shop.ImageUrl}}" alt="{{ config.Shop.Name }}" loading="eager" fetchpriority="high">
                </a>
            </div>
            <div class="cart-header__steps">
                <button class="cart-header__step cart-change-step-js"
                        data-step="{{orderStep}}" 
                        data-set="First"
                >
                    <div class="cart-header__step-icon">
                        <svg>
					    	<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
					    </svg>
                    </div>
                    <div class="cart-header__step-text">{{ translations.Cart }}</div>
                </button>
                <div class="cart-header__steps-separator"></div>
                <button {% unless orderStep == 'orderStep != 'Second' and usr.Authenticated == false -%} tabindex="-1" {% endunless -%} class="cart-header__step {% if orderStep != 'Second' and usr.Authenticated == false -%} cart-change-step-js {% endif -%}"
                        data-step="{{orderStep}}" 
                        data-set="Second"
                >
                    <div class="cart-header__step-icon">
                        {% if orderStep == 'Second' -%}
                            2
                        {% else -%}
                            <svg>
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                            </svg>
                        {% endif -%}
                    </div>
                    <div class="cart-header__step-text">{{ translations.Com_Login }}</div>
                </button>
                <div class="cart-header__steps-separator"></div>
                <button class="cart-header__step {% if orderStep == 'Second' -%} disable {% endif -%}">
                    <div class="cart-header__step-icon">3</div>
                    <div class="cart-header__step-text">{{ translations.Summary }}</div>
                </button>
            </div>
        </div>
    {% endif -%}

    {% if orderStep == 'ThankYou' -%}
        {% include 'partials/cart/thx.html' -%}
    {% else -%}
        {% assign creditStatus = customer.CreditLimit.Status -%}
        {% assign creditLimitActive = customer.CreditLimit.Active -%}
        {% assign creditOverdueActive = customer.CreditLimit.OverdueActive -%}

        {% if usr.Authenticated == false and cart.Customer.DeliveryAddress.Name != '' -%}
            {% assign notAuthWithData = true -%}
        {% endif -%}

        <div class="cart {% if creditStatus == 2 and creditLimitActive or creditOverdueActive -%}credit-limit-blocked{% endif -%}">
            {% if page.QueryString contains 'empty-inquiry=true' -%}
                {% capture backToShoppingLink -%}{{ translations.BackToShopping | Downcase }}{% endcapture -%}
                <div class="cart__empty">
                    <div class="cart__empty-wrapper">
                        <div class="cart__empty-text">{{ translations.EmptyInquiryInfoShort | Format: backToShoppingLink }}</div>
                    </div>
                    <a href="{{ page.BaseHref }}{{ config.DefinedPages.Home.Url | Replace: '^\./', '' }}" class="primary-action-button cart__empty-btn">
                        {{ translations.BackToHome }}
                        <svg>
				        	<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#home-{{settings.iconStyle}}"></use>
				        </svg>
                    </a>
                </div>
            {% else -%}
                {% if cart.CartEmpty -%}
                    <div class="cart__empty">
                        <div class="cart__empty-wrapper">
                            <svg class="cart__empty-icon">
					        	<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{settings.cartIconStyle}}-{{settings.iconStyle}}"></use>
					        </svg>
                            <div class="cart__empty-text">{{ translations.YourCartIsEmpty }}</div>
                        </div>
                        <a href="{{ page.BaseHref }}{{ config.DefinedPages.Home.Url | Replace: '^\./', '' }}" class="primary-action-button cart__empty-btn">
                            {{ translations.BackToHome }}
                            <svg>
					        	<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#home-{{settings.iconStyle}}"></use>
					        </svg>
                        </a>
                    </div>
                {% elseif orderStep == 'Second' -%}
                    <div class="cart__second-step">
                        {% include 'partials/common/login.html' -%}
                        {% if cart.AuthenticationRequired == false or config.Registration.Disabled == false -%}
                            <div class="cart-account-box">
                                {% unless config.Registration.Disabled -%}
                                    <div class="cart-account-box__section">
                                        <div class="cart-account-box__title">{{ translations.MakeAccount }}</div>
                                        <div class="cart-account-box__text">{{ translations.CartMakeAccountInfo }}</div>
                                        <ul class="cart-account-box__list">
                                            <li>
                                                <svg>
                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                                </svg>
                                                <div>{{ translations.CartMakeAccountAdvantageOne }}</div>
                                            </li>
                                            <li>
                                                <svg>
                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                                </svg>
                                                <div>{{ translations.CartMakeAccountAdvantageTwo }}</div>
                                            </li>
                                            <li>
                                                <svg>
                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                                </svg>
                                                <div>{{ translations.CartMakeAccountAdvantageThree }}</div>
                                            </li>
                                        </ul>
                                        <a class="primary-action-button cart-account-box__btn"
                                        href="{{ page.BaseHref }}{{ config.DefinedPages.Registration.Url }}#back-to-cart-{{config.DefinedPages.Order.Url}}" 
                                        title="{{ translations.Register }}"
                                        >
                                            {{ translations.MakeAccount }}
                                        </a>
                                    </div>
                                {% endunless -%}
                                {% if cart.AuthenticationRequired == false and config.Registration.Disabled == false -%}
                                    <div class="cart-account-box__divider cart-hide-on-mobile"></div>
                                {% endif -%}
                                {% if cart.AuthenticationRequired == false -%}
                                    <div class="cart-account-box__section">
                                        <div class="cart-account-box__title cart-hide-on-mobile">{{ translations.CartAsGuest }}</div>
                                        <div class="cart-account-box__text cart-hide-on-mobile">{{ translations.CartAsGuestInfo }}</div>
                                        <button class="primary-action-button cart-account-box__btn secondary-btn cart-change-step-js" 
                                                data-step="{{orderStep}}" 
                                                data-set="Third">
                                            {{ translations.ContinueWithoutSignIn }}
                                        </button>
                                    </div>
                                {% endif -%}
                            </div>
                        {% endif -%}
                    </div>
                {% else -%}
                    {% assign needAutoRecalculate = false -%}
                    {% if cart.Changes -%}
                        {% assign needAutoRecalculate = true -%}
                        {% for change in cart.Changes -%}
                            {% if change.Id != 1 and change.Id != 3 and change.Id != 9 -%}
                                {% assign needAutoRecalculate = false -%}
                            {% endif -%}
                        {% endfor -%}
                    {% endif -%}

                    {% if cart.NotDeterminedDeliveryCost or cart.SelectedDelivery.NotDeterminedDeliveryCost -%}
                        {% assign notDeterminedDeliveryCost = true -%}
                    {% endif -%}
                    {% if cart.ProductsMinimumTotalValue and cart.ProductsTotalValue < cart.ProductsMinimumTotalValue and customer.Cart.EditedOrderId == null -%}
                        <div class="cart__info-bar warning-bar">
                            <svg>
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}"></use>
                            </svg>
                            {% capture minValue -%}<strong>&nbsp;{{cart.ProductsMinimumTotalValue}} {{cart.CurrencyExt}}</strong>.{% endcapture -%}
                            {{translations.ProductsMinimumTotalValue | Format: minValue}}
                        </div>
                    {% elseif notDeterminedDeliveryCost and orderStep == 'First' -%}
                        <div class="cart__info-bar warning-bar">
                            <svg>
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#truck-{{settings.iconStyle}}"></use>
                            </svg>
                            {{ translations.NotDeterminedDeliveryCostInfo }}
                        </div>
                    {% endif -%}

                    {% assign orderValueDiscountsSize = cart.OrderValueDiscounts | Size -%}
                    {% if orderValueDiscountsSize > 0 and usr.Authenticated -%}
                        {% for discount in cart.OrderValueDiscounts -%}
                            {% if discount.ValueFrom > cart.ProductsTotalValueBeforeDiscount -%}
                                {% assign valueFrom = discount.ValueFrom -%}
                                {% assign discountVal = discount.Discount | Normalize -%}
                                {% capture toDiscountStrong -%}<strong>&nbsp;{{valueFrom | Minus: cart.ProductsTotalValueBeforeDiscount}} {{cart.CurrencyExt}}</strong>{% endcapture -%}
                                {% capture discountValStyled -%}<strong>&nbsp;{{discountVal}} %</strong>{% endcapture -%}
                                <div class="cart__info-bar warning-bar">
                                    {{ translations.DiscountInfo | Format:toDiscountStrong,discountValStyled }}
                                </div>
                                {% break -%}
                            {% endif -%}
                        {% endfor -%}
                    {% endif -%}

                    {% if cart.SplitPayment -%}
                        <div class="cart__info-bar warning-bar">
                            {{ translations.SplitPaymentInfo }}
                        </div>
                    {% endif -%}

                    {% if orderStep == 'First' -%}
                        <div class="cart__info-bar success-bar cart-recalculate-bar-js" style="display: none">
                            <svg>
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-circle-{{settings.iconStyle}}"></use>
                            </svg>
                            {{ translations.CartRecalculated }}
                        </div>
                    {% endif -%}

                    <div class="cart__header">
                        <div class="cart__header-title">
                            {% if customer.Cart.Inquiry or page.QueryString contains 'empty-inquiry=true' -%}
                                {{ translations.Inquiry }}
                            {% elseif customer.Cart.EditedOrderId -%}
                                {{ translations.YouAreEditing }}: 
                            {% else -%}
                                {{ translations.Cart }}
                            {% endif -%}
                            {% unless customer.Cart.Inquiry or page.QueryString contains 'empty-inquiry=true' -%}
                                {% if customer.Carts == null -%}
                                    1
                                {% else -%}
                                    {% for oneOfCart in customer.Carts -%}
                                        {% if oneOfCart.Current -%}
                                            {{ oneOfCart.Name }}
                                            {% break -%}
                                        {% endif -%}
                                    {% endfor -%}
                                {% endif -%}
                            {% endunless -%}
                        </div>

                        <div class="cart__header-wrapper cart__header-buttons">
                            {% if config.B2B and settings.inquiries == 'yes' -%}
                                {% if customer.Cart.Inquiry or page.QueryString contains 'empty-inquiry=true' -%}
                                    <button class="cart__action-btn {% unless page.QueryString contains 'empty-inquiry=true' -%} toggle-cart-type-js change-into-cart-js {% endunless -%}" data-message="{{translations.InquiryIntoCartInfo}}">
                                        <svg>
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{settings.cartIconStyle}}-{{settings.iconStyle}}"></use>
                                        </svg>
                                        <span>{{ translations.ChangeIntoCart }}</span>
                                    </button>
                                {% else -%}
                                    {% assign offerExists = false -%}
                                    {% for product in cart.Products -%}
                                        {% if product.AskForPrice -%}
                                            {% assign offerExists = true -%}
                                        {% endif -%}
                                    {% endfor -%}
                                    <button class="cart__action-btn {% unless offerExists -%} toggle-cart-type-js {% endunless -%}" data-message="{{translations.CartIntoInquiryInfo}}" data-order-step="{{orderStep}}" {% if offerExists -%} disabled {% endif -%}>
                                        <svg>
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-dollar-{{settings.iconStyle}}"></use>
                                        </svg>
                                        <span>{{ translations.ChangeIntoInquiry }}</span>
                                    </button>
                                {% endif -%}
                            {% endif -%}
                            {% unless customer.Cart.EditedOrderId -%}
                                {% if orderStep == 'First' -%}
                                    <button class="cart__action-btn open-delete-cart-confirmation-js">
                                        <svg>
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
                                        </svg>
                                        <span>
                                            {% if customer.Cart.Inquiry or page.QueryString contains 'empty-inquiry=true' -%}
                                                {{ translations.DeleteInquiry }} 
                                            {% else -%}
                                                {{ translations.DeleteCart }}
                                            {% endif -%}
                                        </span>
                                    </button>

                                    <div class="cart__popup cart-popup-js delete-cart-confirmation-js hidden-js">
                                        <div class="cart__popup-box">
                                            <div class="cart__popup-header">
                                                <div class="cart__popup-title">
                                                    <svg class="warning-icon">
                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}"></use>
                                                    </svg>
                                                    <span>
                                                        {{ translations.Delete }}
                                                        {% if page.QueryString contains 'inquiry=true' -%}
                                                            {{ translations.InquiryShort | Downcase }}
                                                        {% else -%}
                                                            {{ translations.Cart | Downcase }}
                                                        {% endif -%}
                                                    </span>
                                                </div>
                                                <button aria-label="{{ translations.Close }}" class="cart__popup-closer cart-popup-closer-js">
                                                    <svg>
                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                            <div class="cart__popup-content">
                                                <div>
                                                    {% if page.QueryString contains 'inquiry=true' -%}
                                                        {{ translations.DeleteInquiryInfo }}:
                                                    {% else -%}
                                                        {{ translations.DeleteCartInfo }}:
                                                    {% endif -%}  
                                                    <strong>
                                                        {% if page.QueryString contains 'inquiry=true' -%}
                                                            {{ translations.InquiryShort }}
                                                        {% else -%}
                                                            {{ translations.Cart }}
                                                        {% endif -%} 
                                                        {% if customer.Carts == null -%}
                                                            1
                                                        {% else -%}
                                                            {% for oneOfCart in customer.Carts -%}
                                                                {% if oneOfCart.Current -%}
                                                                    <span class="cart-name-to-replace-js">{{oneOfCart.Name}}</span>
                                                                    {% break -%}
                                                                {% endif -%}
                                                            {% endfor -%}
                                                        {% endif -%}
                                                    </strong>
                                                    ?
                                                </div>
                                                <br >
                                                <button aria-label="{{ translations.Yes }}, {{ translations.Delete | Downcase }}" class="primary-action-button delete-cart-js">
                                                    {{ translations.Yes }}, {{ translations.Delete | Downcase }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                {% endif -%}
                            {% endunless -%}
                        </div>
                    </div>

                    <div class="cart-products-container-js container-js" data-include="{{pageNumber}}">
                        {% include 'partials/cart/products-partials/products.html' with pageNumber -%}
                    </div>

                    {% unless customer.Cart.Inquiry -%}
                        {% if customer.Cart.EditedOrderId == null -%}
                            {% if cart.ProductsMinimumTotalValue == null or cart.ProductsTotalValue > cart.ProductsMinimumTotalValue -%}
                                <div class="cart__options {% if orderStep == 'First' -%} first-step {% elseif orderStep == 'Third' -%} third-step {% endif -%}">
                                    {% if orderStep == 'Third' -%}
                                        <div class="cart__data cart__delivery-section delivery-section-container-js">
                                            {% include 'partials/cart/delivery-partials/delivery-section.html' with 'init' -%}
                                        </div>
                                    {% endif -%}
                                    {% if settings.loyaltyProgram == "yes" and orderStep == 'First' -%}
                                        {% if cart.Coupon == null -%}
                                            {% if cart.Points or cart.PointsForValue != null -%}
                                                {% capture points -%} <strong>{{ cart.Points | ToString }}</strong> {% endcapture -%}
                                                <div class="cart__loyalty-info">
                                                    <svg>
                                                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#award-{{settings.iconStyle}}'></use>
                                                    </svg>
                                                    <span>
                                                        {% if usr.Authenticated -%}
                                                            {% assign goodsPoints = cart.Points | Minus: cart.PointsForValue -%}
                                                            {% if points != null %}
                                                                <p>{{ translations.LoyaltyPointsForOrder | Format: points }} <strong>{{ translations.PointsShortcut }}</strong>.</p>
                                                            {% elsif cart.PointsForValue != null %}
                                                                <p>{{ translations.LoyaltyPointsForGoods | Format: points }} <strong>{{ translations.PointsShortcut }}</strong>.</p>
                                                            {% endif %}
                                                            
                                                            {% if goodsPoints > 0 %}
                                                                <p>{{ translations.Goods }}: <strong>+{{ goodsPoints }} {{ translations.PointsShortcut }}</strong>.</p>
                                                            {% endif %}
                                                            
                                                            {% if cart.PointsForValue != null  -%}
                                                                {% if cart.Points != cart.PointsForValue -%}
                                                                    <p>{{ translations.OrderTotalPrice }}: <strong>+{{ cart.PointsForValue }} {{ translations.PointsShortcut }}</strong>.</p>
                                                                {% endif %}
                                                            {% endif %}
                                                        {% else %}
                                                            <p>{{ translations.LoyaltyInfoForNotLogged | Format: points }}</p>
                                                        {% endif %}
                                                    </span>
                                                </div>
                                            {% endif -%}
                                        {% endif -%}
                                    {% endif -%}

                                    {% include 'partials/cart/order-summary.html' -%}
                                    {% if orderStep == 'First' -%}
                                        <a href="{{ page.BaseHref }}{{ config.DefinedPages.Home.Url | Replace: '^\./', '' }}" class="cart__back-btn cart__action-btn">
                                            <svg>
                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-left-{{settings.iconStyle}}"></use>
                                            </svg>
                                            {{ translations.BackToShopping }}
                                        </a>
                                        <button class="cart__next-btn primary-action-button cart-change-step-js" 
                                                data-step="{{orderStep}}" 
                                                data-set="{% if usr.Authenticated -%}Third{% else -%}Second{% endif -%}">
                                            {{ translations.GoToCheckout }}
                                        </button>
                                    {% endif -%}
                                </div>
                            {% endif -%}
                        {% endif -%}
                    {% endunless -%}

                    {% if customer.Cart.Inquiry or page.QueryString contains 'empty-inquiry=true' -%}
                        <div class="cart__options inquiry-step">
                            <div class="cart__inquiry form-js" novalidate>
                                <div class="cart-data-section">
                                    <div class="cart-data-section__header">
                                        <div class="cart-data-section__header-title">
                                            <div>
                                                {{ translations.MyData }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cart-data-section__content">
                                        <div class='form__required-fields'><span class='required'>*</span> {{ translations.RequiredFields }}</div>
                                        <div class="form__input-wrapper">
                                            <label for="email" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.Email}} </label>
                                            <input class="form__input-value input-value-js" id="email" type="text" name="email" value="{{customer.Email}}" autocomplete="email" maxlength="50" required >
                                            <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillEmail }}</div>
                                            <div class="form__invalid-input validation-email-js hidden-js">{{ translations.FillProperEmail }}</div>
                                        </div>
                                        <div class="form__input-wrapper">
                                            <label for="name" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.CompanyName }} {{ translations.Or | Downcase }} {{ translations.NameAndSurname | Downcase }} </label>
                                            <input class="form__input-value input-value-js" id="name" type="text" name="name" value="{{ customer.Address.Name | H }}{{ customer.Address.Name2 | H }}" maxlength="128" required >
                                            <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillCompanyName }}</div>
                                        </div>
                                        <div class="form__input-wrapper">
                                            <label for="phoneNo" class="form__input-info input-info-js"> {{ translations.PhoneNumber }} </label>
                                            <input class="form__input-value input-value-js" id="phoneNo" type="tel" inputmode="numeric" pattern="\d*" name="phoneNo" value="{{ customer.Address.PhoneNo }}" maxlength="20" data-error="{{ translations.FillPhoneNumber }}" >
                                            <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillCompanyName }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cart-data-section">
                                    <div class="cart-data-section__header">
                                        <div class="cart-data-section__header-title">
                                            <div>
                                                {{translations.Notes}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cart-data-section__content note-js">
                                        {% include 'partials/cart/note-partials/note-form.html' with 'true' -%}
                                    </div>
                                </div>

                                {% if cart.AuthenticationRequired and usr.Authenticated == false -%}
                                    <div>
                                        <div>
                                            {{ translations.FinishInquiry }}
                                            {% if config.Registration.Disabled -%}
                                                {{ translations.SignIn }}.
                                            {% else -%}
                                                {{ translations.SignInToCreateAccount }}.
                                            {% endif -%}
                                        </div>
                                        <div class="cart__inquiry-wrapper">
                                            <a aria-label="{{ translations.LogIn }}" class="cart__action-btn" href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}#back-to-cart-{{config.DefinedPages.Order.Url}}" rel="nofollow">{{ translations.LogIn }}</a>
                                            {% if config.Registration.Disabled == false -%}
                                                <a aria-label="{{ translations.MakeAccount }}" class="cart__action-btn" href="{{ page.BaseHref }}{{ config.DefinedPages.Registration.Url }}#back-to-cart-{{config.DefinedPages.Order.Url}}" rel="nofollow">{{ translations.MakeAccount }}</a>
                                            {% endif -%}
                                        </div>
                                    </div>
                                {% else -%}
                                    <div class="cart__consents cart-consents-js">
                                        <input type="hidden" name="__action" value="Inquiry/Add" >

                                        <div class='form__required-fields'><span class='required'>*</span> {{ translations.RequiredFields }}</div>
                                        {% for tos in config.TOS.Consents.Inquiries -%}
                                            {% assign channelsSize = tos.Channels | Size -%}
                                            {% if channelsSize > 0 -%}
                                                {% assign onlyEmail = false -%}
                                                {% if channelsSize == 1 and tos.Channels[0].Type == 1 -%}
                                                    {% assign onlyEmail = true -%}
                                                {% endif -%}
                                                {% if onlyEmail == false -%}
                                                    <div class="cart__tos-error validation-info-js validation-channel-js hidden-js">{{ translations.ChooseOption }}</div>
                                                {% endif -%}
                                            {% endif -%}
                                            <div class="cart__tos-consent tos-container-js {% if tos.Statement -%} statement-js {% endif -%}" >
                                                {% if tos.Statement -%}
                                                    {% unless channelsSize == 1 -%}
                                                        <div>{% if tos.Required-%}<span class="cart__tos-required">* </span>{% endif -%} {{tos.Text | Replace: '\.', ' ' }}{% if channelsSize > 0 -%} {{translations.Consents_InTheFormOf}}:{% endif -%}</div>
                                                    {% endunless -%}
                                                {% else -%}
                                                    <label {% unless channelsSize > 0 -%} tabindex="0" role="checkbox" aria-checked="false" {% endunless -%} class="cart__tos-label tos-js">
                                                        {% if channelsSize == 1 -%}
                                                            <input aria-label="tos" type="checkbox" name="tos" value="{{ tos.Id }}" {% if tos.Required -%} required {% endif -%} >
                                                        {% elsif channelsSize > 0 -%}
                                                            <input aria-label="tos" type="checkbox" name="tos" value="{{ tos.Id }}" {% if tos.Required -%} required {% endif -%} >
                                                            {% if tos.Required-%}<span class="cart__tos-required">* </span>{% endif -%} {{tos.Text | Remove: '.' }} {{translations.Consents_InTheFormOf}}:
                                                            {% if tos.Required -%}
                                                                <div class="cart__tos-error validation-info-js validation-required-js hidden-js">{{ translations.RequiredField }}</div>
                                                            {% endif -%}
                                                        {% else -%}
                                                            <input  aria-label="tos" type="checkbox" name="tos" value="{{ tos.Id }}" {% if tos.Required -%} required {% endif -%} >
                                                            <div class="cart__tos-checkbox">
                                                                <svg>
                                                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                                                </svg>
                                                            </div>
                                                            <div class="cart__tos-consent-label">
                                                                {% if tos.Required -%}<span class="cart__tos-required">*</span> {% endif -%}{{ tos.Text }}
                                                            </div>
                                                            {% if tos.Required -%}
                                                                <div class="cart__tos-error validation-info-js validation-required-js hidden-js">{{ translations.RequiredField }}</div>
                                                            {% endif -%}
                                                        {% endif -%}
                                                    </label>
                                                {% endif -%}
                                                {% if channelsSize > 0 -%}
                                                    {% if onlyEmail == false -%}
                                                        <div class="cart__tos-error validation-info-js validation-channel-js hidden-js">{{ translations.ChooseOption }}</div>
                                                    {% endif -%}
                                                {% endif -%}
                                                {% for channel in tos.Channels -%}
                                                    <label tabindex="0" role="checkbox" aria-checked="false" class="cart__tos-label {% if channelsSize > 0 -%} channel-js {% endif -%}">
                                                        {% if tos.Statement -%}
                                                            {% if channelsSize == 1 -%}
                                                                <input type="hidden" name="channelKey" value="{{ channel.Key }}" checked >
                                                                <input aria-label="channelKey" type="checkbox" checked disabled >
                                                                <div class="cart__tos-checkbox">
                                                                    <svg>
                                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                                                    </svg>
                                                                </div>
                                                                <div>{% if tos.Required-%}<span class="cart__tos-required">* </span>{% endif -%} {{tos.Text | Remove: '.' }} {{translations.Consents_InTheFormOf}} {% unless channel.Name == "SMS" -%} {{ channel.Name | Downcase }}. {% else -%} {{ channel.Name }}. {% endunless -%}</div>
                                                            {% elsif channelsSize > 0 -%}
                                                                <input aria-label="channelKey" type="checkbox" name="channelKey" value="{{ channel.Key }}" checked >
                                                                <div class="cart__tos-checkbox">
                                                                    <svg>
                                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                                                    </svg>
                                                                </div>
                                                                <div>{{ channel.Name }}</div>
                                                            {% endif -%}
                                                        {% else -%}
                                                            {% if channelsSize == 1 -%}
                                                                <input  aria-label="channelKey" type="checkbox" name="channelKey" value="{{ channel.Key }}" >
                                                                <div class="cart__tos-checkbox">
                                                                    <svg>
                                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                                                    </svg>
                                                                </div>
                                                                <div class="cart__tos-consent-label">
                                                                    {% if tos.Required-%}<span class="cart__tos-required">* </span>{% endif -%} {{tos.Text | Remove: '.' }} {{translations.Consents_InTheFormOf}} {% unless channel.Name == "SMS" -%} {{ channel.Name | Downcase }}. {% else -%} {{ channel.Name }}. {% endunless -%}
                                                                </div>
                                                            {% elsif channelsSize > 0 -%}
                                                                <input  aria-label="channelKey" type="checkbox" name="channelKey" value="{{ channel.Key }}" >
                                                                <div class="cart__tos-checkbox">
                                                                    <svg>
                                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
                                                                    </svg>
                                                                </div>
                                                                <div class="cart__tos-consent-label">{{ channel.Name }}</div>
                                                            {% endif -%}
                                                        {% endif -%}
                                                    </label>
                                                {% endfor -%}
                                            </div>
                                        {% endfor -%}
                                        <button aria-label="inquiry-recalculate" class="cart__inquiry-btn primary-action-button parent-container-reload-js add-inquiry-js" data-value="{{cart.ProductsTotalValue}}" data-products-quantity="{{cart.Products | Size}}" data-date="{{config.Now | Date:dateFormat}}">
                                            {{translations.AddInquiry}}
                                        </button>
                                    </div>
                                {% endif -%}
                            </div>
                        </div>
                    {% endif -%}
                {% endif -%}
            {% endif -%}
        </div>

        {% if customer.Cart.Inquiry == false -%}
            {% if orderStep == 'First' -%}
                {% assign discountItemsProducts = cart.GratisItems -%}
                {% assign isDiscountProduct = true -%}
                {% assign discountItemsProductsSize = discountItemsProducts | Size -%}
                {% if discountItemsProductsSize > 0 -%}
                    <div class="cart-recommendations">
                        <div class="cart-recommendations__title">{{ translations.ChooseDiscountProduct }}</div>
                        {% include 'partials/cart/products-partials/recommended.html', products: discountItemsProducts, isDiscountItem: isDiscountProduct -%}
                    </div>
                {% endif -%}
            {% endif -%}

            {% if settings.recommendedAIInCart == 'yes' -%}
                {% if orderStep == 'First' or orderStep == 'ThankYou' -%}
                    {% assign recommendedAIProducts = cross-selling.Products -%}
                    {% assign isDiscountProduct = false -%}
                    {% assign recommendedAIProductsSize = recommendedAIProducts | Size -%}
                    {% if recommendedAIProductsSize > 0 -%}
                        <div class="cart-recommendations">
                            <div class="cart-recommendations__title">{{ translations.ChosenForYou }}</div>
                            {% include 'partials/cart/products-partials/recommended.html', products: recommendedAIProducts, isDiscountItem: isDiscountProduct -%}
                            <div class="ai-generated-content">{{ translations.AiGeneratedProductsRecommendations }}</div>
                        </div>
                    {% endif -%}
                {% endif -%}
            {% endif -%}
        {% endif -%}

        {% if orderStep == 'Second' or orderStep == 'Third' -%}
            <div class="cart-footer">
                {% assign year = config.Now | Date : "yyyy" -%}

                {% assign dataString = '' -%}
                        
                {% if config.Shop.Name != '' -%}
                    {% assign dataString = dataString | Append: config.Shop.Name  -%}       
                    
                    {% if config.Shop.Address.Street != '' or config.Shop.Address.StreetNo != '' or config.Shop.Address.ZipCode != '' or config.Shop.Address.City != '' or config.Shop.Address.Country != '' or config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                        {% assign dataString = dataString | Append: ', '  -%}       
                    {% endif -%}
                {% endif -%}

                {% if config.Shop.Address.Street != '' -%}
                    {% assign dataString = dataString | Append: config.Shop.Address.Street | Append: ' ' -%}
                {% endif -%}

                {% if config.Shop.Address.StreetNo != '' -%}
                    {% if config.Shop.Address.UnitNo != '' -%}
                        {% assign dataString = dataString | Append: config.Shop.Address.StreetNo / config.Shop.Address.UnitNo -%} 
                    {% else -%}
                        {% assign dataString = dataString | Append: config.Shop.Address.StreetNo -%} 
                    {% endif -%}

                    {% if config.Shop.Address.ZipCode != '' or config.Shop.Address.City != '' or config.Shop.Address.Country != '' or config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                        {% assign dataString = dataString | Append: ', ' -%}       
                    {% endif -%}
                {% endif -%}

                {% if config.Shop.Address.ZipCode != '' -%}
                    {% assign dataString = dataString | Append: config.Shop.Address.ZipCode -%} 
                            
                    {% if config.Shop.Address.City != '' or config.Shop.Address.Country != '' or config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                        {% assign dataString = dataString | Append: ', ' -%}       
                    {% endif -%}
                {% endif -%}

                {% if config.Shop.Address.City != '' -%}
                    {% assign dataString = dataString | Append: config.Shop.Address.City -%} 

                    {% if config.Shop.Address.Country != '' or config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                        {% assign dataString = dataString | Append: ', ' -%}       
                    {% endif -%}
                {% endif -%}

                {% if config.Shop.Address.Country != '' -%}
                    {% assign dataString = dataString | Append: config.Shop.Address.Country -%} 

                    {% if config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                        {% assign dataString = dataString | Append: ', ' -%}       
                    {% endif -%}
                {% endif -%}

                {% if config.Shop.Registrant != '' -%}
                    {% assign dataString = dataString | Append: config.Shop.Registrant -%} 

                    {% if config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                        {% assign dataString = dataString | Append: ', ' -%}       
                    {% endif -%}
                {% endif -%}

                <p>
                    {{ dataString }}

                    {% if config.Shop.TIN != '' -%}
                        {% if config.Shop.Regon != '' -%}
                            {{ translations.Prf_NIP }}: {{ config.Shop.TIN }},
                        {% else -%}
                            {{ translations.Prf_NIP }}: {{ config.Shop.TIN }}
                        {% endif -%}
                    {% endif -%}

                    {% if config.Shop.Regon != '' -%}
                        {{ translations.Prf_REGON }}: {{ config.Shop.Regon }}
                    {% endif -%}
                </p>

                <p>
                    {{ translations.Copyright  | Format: year }} <a href="{{config.Application.Website}}">{{config.Application.Name}} ®</a>
                </p>
            </div>
        {% endif -%}  
    {% endif -%}
</div>

<div class="during-ajax-modal-js during-ajax-modal hidden-js">
    <div class="loader big"></div>
</div>
`